import { JournalEntryKeys, JournalEntry, EntrySize } from '../typings'
import { getObjectSize } from './getObjectSize'

export const getEntrySize = (entry: JournalEntry): EntrySize => {
  return getObjectSize<JournalEntryKeys>({ ...entry })
}
